import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { CaseServiceCall } from 'types/urgently'
import { StandardServiceCall } from 'types/aaa'
import { allStateData } from 'types/allstate'

type RecentDispatchState = {
  AAADispatches: StandardServiceCall[]
  ULYDispatches: CaseServiceCall[]
  AllstateDispatches: allStateData[]
}

const initialState: RecentDispatchState = {
  AAADispatches: new Array<StandardServiceCall>(),
  ULYDispatches: new Array<CaseServiceCall>(),
  AllstateDispatches: new Array<allStateData>(),
}

const recentDispatchSlice = createSlice({
  name: 'RecentDispatches',
  initialState,
  reducers: {
    addRecentAAADispatch: (state: RecentDispatchState, action: PayloadAction<StandardServiceCall>) => {
      state.AAADispatches.push(action.payload)
    },
    removeRecentAAADispatch: (state: RecentDispatchState, action: PayloadAction<string>) => {
      state.AAADispatches = state.AAADispatches.filter((dispatch) => dispatch.callKey !== action.payload)
    },
    addRecentULYDispatch: (state: RecentDispatchState, action: PayloadAction<CaseServiceCall>) => {
      state.ULYDispatches.push(action.payload)
    },
    removeRecentULYDispatch: (state: RecentDispatchState, action: PayloadAction<string>) => {
      state.ULYDispatches = state.ULYDispatches.filter((dispatch) => dispatch.case.id !== action.payload)
    },
    addRecentAllstateDispatch: (state: RecentDispatchState, action: PayloadAction<allStateData>) => {
      state.AllstateDispatches.push(action.payload)
    },
    updateRecentAllstateDispatchStatusById: (state, action: PayloadAction<allStateData>) => {
      const getId = (d: allStateData) => String(d?.serviceRequest?.callId ?? '')
      const id = String(action.payload.serviceRequest?.callId)
      const item = state.AllstateDispatches.find((d) => getId(d) === id)
      if (item) {
        item.serviceRequest.status = action.payload.serviceRequest.status
      }
    },
    removeRecentAllstateDispatch: (state: RecentDispatchState, action: PayloadAction<string>) => {
      state.AllstateDispatches = state.AllstateDispatches.filter(
        (dispatch) => dispatch?.serviceRequest?.callId !== action.payload,
      )
    },
    resetRecentDispatches: (state: RecentDispatchState) => {
      state = initialState
      return state
    },
  },
})

export const {
  addRecentAAADispatch,
  removeRecentAAADispatch,
  addRecentULYDispatch,
  removeRecentULYDispatch,
  addRecentAllstateDispatch,
  removeRecentAllstateDispatch,
  updateRecentAllstateDispatchStatusById,
  resetRecentDispatches,
} = recentDispatchSlice.actions

export default recentDispatchSlice.reducer
